import React from "react";
import { useTranslation } from "react-i18next";
import type { ProcessCaseSelection } from "./useProcessCaseSelection";

export default function ProcessCaseSelectionFooter({
  selection,
  loading,
}: { selection: ProcessCaseSelection; loading: boolean }) {
  const { t } = useTranslation();
  if (!selection.editing) return null;
  return (
    <div className="flex shrink-0 flex-wrap items-center gap-2 border-t border-outline bg-surface px-4 py-3">
      <div className="min-w-0 flex-1 text-xs text-text-mid" aria-live="polite">
        <p className="font-medium tabular-nums">{t("processPanel.chooseCasesHelp")}</p>
        {selection.hiddenPicks > 0 && (
          <p className="mt-0.5 text-text-dim">
            {t("processPanel.hiddenSelections", { count: selection.hiddenPicks })}
          </p>
        )}
      </div>
      <button
        type="button"
        onClick={selection.cancel}
        className="rounded-full border border-outline px-3 py-2 text-xs text-text-mid hover:bg-surface-strong focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-info/30"
      >
        {t("cancel")}
      </button>
      <button
        type="button"
        onClick={selection.apply}
        disabled={loading || !selection.includedIds.length}
        className="rounded-full bg-primary px-3 py-2 text-xs font-medium text-on-accent disabled:opacity-40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-info/30"
      >
        {t("processPanel.showCasesInGraph", { count: selection.includedIds.length })}
      </button>
    </div>
  );
}
